import moment from 'moment';

export function getFutureDateRanges() {
  return [
    {
      text: 'Today',
      range: [moment(), moment()],
    },
    {
      text: 'Next 3 days',
      range: [moment(), moment().add(3, 'days')],
    },
    {
      text: 'Next 7 days',
      range: [moment(), moment().add(7, 'days')],
    },
    {
      text: 'Next 30 days',
      range: [moment(), moment().add(30, 'days')],
    },
    {
      text: 'This month',
      range: [moment().startOf('month'), moment().endOf('month')],
    },
    {
      text: 'Custom',
      range: [moment(), moment()],
    },
  ];
}

export const getDefaultPastDateRanges = () => {
  return [
    {
      text: 'Today',
      range: [moment(), moment()],
    },
    {
      text: 'Last 3 days',
      range: [moment().subtract(3, 'days'), moment()],
    },
    {
      text: 'Last 7 days',
      range: [moment().subtract(7, 'days'), moment()],
    },
    {
      text: 'Last 30 days',
      range: [moment().subtract(30, 'days'), moment()],
    },
    {
      text: 'This month',
      range: [moment().startOf('month'), moment().endOf('month')],
    },
    {
      text: 'Custom',
      range: [moment(), moment()],
    },
  ];
};

export const getTodayObj = () => {
  return {
    dateStart: new Date(),
    dateEnd: new Date(),
  };
};
